/**
 * Unified Clone Utility
 *
 * Single source of truth for all cloning operations in the application.
 * Uses native structuredClone when available, falls back to JSON for compatibility.
 */

/**
 * Deep clone any value (objects, arrays, primitives)
 *
 * Uses native structuredClone (faster) when available,
 * falls back to JSON.parse/stringify for older browsers.
 *
 * NOTE: Cannot clone functions, symbols, or circular references with JSON fallback
 */
export function deepClone<T>(value: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
}
